module.exports = __webpack_public_path__ + "static/media/Avatars_Female-24.04b6de1a.png";